import { Navigate } from 'react-router-dom';

interface AdminRouteProps {
    isAdmin: boolean;
    children: JSX.Element;
}

const AdminRoute = ({ isAdmin, children }: AdminRouteProps) => {
    return isAdmin ? children : <Navigate to="/home" replace />;
};

export default AdminRoute;
